import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar } from 'lucide-react';
import './LatestNews.css';
import {
  getLatestNewsPreviews,
  NewsArticlePreview,
} from '../data/newsArticles';

interface LatestNewsProps {
  articles?: NewsArticlePreview[];
  showViewAll?: boolean;
  maxArticles?: number;
}

const LatestNews: React.FC<LatestNewsProps> = ({
  articles,
  showViewAll = true,
  maxArticles = 2,
}) => {
  const displayArticles =
    articles ?? getLatestNewsPreviews(maxArticles);

  return (
    <section className="latest-news">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Latest News</h2>
          {showViewAll && (
            <Link to="/news" className="view-all-link">
              <Calendar size={16} />
              View All News
            </Link>
          )}
        </div>
        <div className="news-grid">
          {displayArticles.map((news) => (
            <Link
              key={news.id}
              to={`/news/${news.id}`}
              className="news-card"
              aria-label={`Read full article: ${news.title}`}
            >
              <div className="news-image">
                <img src={news.image} alt={news.title} />
              </div>
              <div className="news-content">
                <div className="news-meta">
                  <span className="news-date">{news.date}</span>
                </div>
                <h3 className="news-title">{news.title}</h3>
                <p className="news-excerpt">{news.excerpt}</p>
                <span className="read-more">Read More →</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LatestNews;
